import { useEffect, useRef, useState } from 'react';
import './MinMaxEv.css';
import down_icon from '../../../assets/images/down_icon.svg';

const PercentageInput = ({ value, setFilters, filters, index, rowIndex, saveUserInfo, email, isArbitrage, isOutliers }) => {
	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<input
				type="number"
				value={value}
				onChange={async (e) => {
					const copy = JSON.parse(JSON.stringify(filters));
					copy[rowIndex].minMaxEv[index] = Number(e.target.value) || (index === 0 ? -9999999 : 9999999);
					setFilters(copy);
					if (!isArbitrage && !isOutliers) {
						await saveUserInfo(copy, email);
					}
				}}
				style={{
					width: '70px',
					height: '32px',
					backgroundColor: '#17191d',
					border: '2px solid #363844',
					borderRadius: '6px',
					paddingLeft: '8px',
				}}
				placeholder="Any"
			/>
			<span style={{ marginLeft: '4px' }}>%</span>
		</div>
	);
};

export const MinMaxEvComponent = (props) => {
	const { filters, setFilters, index, saveUserInfo, email, isArbitrage, isOutliers, forceOpen } = props;
	const [isOpen, setIsOpen] = useState(false);
	const ref = useRef(null);

	// Open if forceOpen is true
	useEffect(() => {
		if (forceOpen) setIsOpen(true);
	}, [forceOpen]);

	// Close on outside click
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (ref.current && !ref.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const minEv = filters?.[index]?.minMaxEv?.[0] ?? -9999999;
	const maxEv = filters?.[index]?.minMaxEv?.[1] ?? 9999999;

	return (
		<div ref={ref} style={{ height: '140px', position: 'relative' }}>
			<div className="flex flex-row ml-4">
				<div className="flex flex-col" style={{ width: '180px' }}>
					<div style={{ fontSize: '1.25rem', marginBottom: '10px' }}>
						{!isArbitrage && !isOutliers && 'Min/Max EV'}
						{isArbitrage && 'Min/Max ROI'}
						{isOutliers && <div style={{ fontSize: 18 }}>Min/Max Discrepancy</div>}
					</div>

					<div
						onClick={() => setIsOpen(!isOpen)}
						style={{
							height: '58px',
							width: '100%',
							minWidth: 180,
							backgroundColor: '#17191d',
							border: '2px solid #363844',
							borderRadius: '6px',
							borderBottomLeftRadius: isOpen ? 0 : '6px',
							borderBottomRightRadius: isOpen ? 0 : '6px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							padding: '0 10px',
						}}>
						<div>
							{minEv === -9999999 ? 'Any' : minEv}% / {maxEv === 9999999 ? 'Any' : maxEv}%
						</div>
						<img
							src={down_icon}
							style={{
								transform: isOpen ? 'rotate(180deg)' : 'none',
								transition: 'transform 0.2s ease-in-out',
							}}
							alt="down arrow"
						/>
					</div>

					{isOpen && (
						<div
							style={{
								position: 'absolute',
								top: '84px',
								left: '1rem',
								zIndex: 10,
								backgroundColor: '#17191d',
								borderRadius: '6px',
								borderTopLeftRadius: 0,
								borderTopRightRadius: 0,
								border: '2px solid #363844',
								borderTop: 'none',
								width: '180px',
							}}
							className="p-3">
							<div className="flex justify-between">
								<div>
									<div className="mb-2">
										{!isOutliers && (isArbitrage ? 'Minimum ROI' : 'Minimum')}
										{isOutliers && 'Minimum'}
									</div>
									<PercentageInput
										value={filters?.[index]?.minMaxEv?.[0] === -9999999 ? '' : filters?.[index]?.minMaxEv?.[0]}
										setFilters={setFilters}
										filters={filters}
										index={0}
										rowIndex={index}
										saveUserInfo={saveUserInfo}
										email={email}
										isArbitrage={isArbitrage}
										isOutliers={isOutliers}
									/>
								</div>
								<div>
									<div className="mb-2">
										{!isOutliers && (isArbitrage ? 'Maximum ROI' : 'Maximum')}
										{isOutliers && 'Maximum'}
									</div>
									<PercentageInput
										value={filters?.[index]?.minMaxEv?.[1] === 9999999 ? '' : filters?.[index]?.minMaxEv?.[1]}
										setFilters={setFilters}
										filters={filters}
										index={1}
										rowIndex={index}
										saveUserInfo={saveUserInfo}
										email={email}
										isArbitrage={isArbitrage}
										isOutliers={isOutliers}
									/>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
